import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginForm from '../components/auth/LoginForm';
import useAuthStore from '../stores/authStore';
import { getAndClearLoginError } from '../utils/loginErrorMessage';
import { getAndClearReturnUrl, getValidReturnUrlOrDefault } from '../utils/returnUrl';

/**
 * Inlogpagina — doorverwijzen als de gebruiker al is ingelogd (bijv. na Microsoft-redirect).
 */
function LoginPage() {
  const navigate = useNavigate();
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const [bootstrapLoginError] = useState(() => getAndClearLoginError());

  useEffect(() => {
    if (isAuthenticated) {
      const returnUrl = getAndClearReturnUrl();
      const target = getValidReturnUrlOrDefault(returnUrl);
      navigate(target || '/projects', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return <LoginForm initialError={bootstrapLoginError || ''} />;
}

export default LoginPage;
